import { Box, Paper } from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";

import styles from "./dashboard.module.scss";
import i18next from "i18next";

import { useNavigate } from "react-router-dom";
import _ from "lodash";

import DashboardDealer from "../../components/dashboardDealer/DashboardDealer";

import TextBoxCompOne from "../../components/textBoxCompOne/TextBoxCompOne";
import {
  getDealerList,
  getDashboardDealercount,
  getDashboardVehiclecount,
} from "../../services/APIService";
import { useApiErrorModalContext } from "../../errorHandling/ApiErrorModalContext";

import StatusText from "../../components/statusText/StatusText";
import DataTable from "../../components/dataTable/DataTable";

import { getStatusClassName } from "../../utils/commonFuntion";
import Button from "../../components/buttons/Buttons";
import Tooltip from "@mui/material/Tooltip";
import SoftwareGraphComponent from "./components/softwareGraphComponent/SoftwareGraphComponent";
import TurnoverGraphComponent from "./components/TurnoverGraphComponent";
import TrademarkGraphComponent from "./components/TrademarkGraphComponent";
import ApiStatusDashboardcomponent from "./components/ApiStatusDashboardComponent";
import moment from "moment";
import { useAuth } from "../../auth/AuthContext";
export function TooltipWrapper(val, styleval, size) {
  let width = 0;
  if (val?.length > 20 && val?.length < 25) {
    width = val?.length * 8;
  } else {
    width = val?.length * 7;
  }

  if (val?.length <= size) {
    return <Box className={styleval}>{val}</Box>;
  } else
    return (
      <Tooltip
        disableInteractive
        title={val}
        PopperProps={{
          sx: {
            "& .MuiTooltip-tooltip": {
              width: width,
              padding: "2px 0px",
              textAlign: "center",
              fontSize: "12px",
              color: "common.white",
              backgroundColor: "#808080",
              borderRadius: "5px",
            },
          },
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, -5],
              },
            },
          ],
        }}
      >
        <Box className={styleval}>{`${String(val).slice(0, size)}.....`}</Box>
      </Tooltip>
    );
}

export default function Dashboard(props) {
  const { user } = useAuth();
  const userName = _.get(user, "displayName", _.get(user, "userName", ""));
  const [tableHeader, setTableHeader] = useState([]);
  const [tableColumnData, setTableColumnData] = useState([]);
  const { setApiErrorModalState } = useApiErrorModalContext();

  const [dealerCount, setDealerCount] = useState([]);
  const [vehicleCount, setVehicleCount] = useState([]);
  const [apiDealerpayload, setApiDealerpayload] = useState(1);
  const [apiVehiclepayload, setApiVehiclepayload] = useState(1);
  const [pendinTablecount, setPendinTablecount] = useState();
  const [dealersList, setDealersList] = useState([]);

  const [alignment, setAlignment] = useState("today");

  const defaultDealerApiParam = {
    IsDesc: false,
    PageNumber: 1,
    PageSize: 5,
    Status: 3,
  };

  const history = useNavigate();
  

  const fetchDealerList = useCallback(() => {
    getDealerList(defaultDealerApiParam)
      ?.then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          setDealersList(_.get(response, "dealerDtoList", []));

          setPendinTablecount(response.totalPendingDealer);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchDealerList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchdealerCount = useCallback(() => {
    getDashboardDealercount({ period: apiDealerpayload })
      ?.then((response) => {
        if (!_.isEmpty(_.get(response, "errorMessage", "")) || _.get(response, "success", true) === false) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          setDealerCount(response);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
  }, [apiDealerpayload, setApiErrorModalState]);

  const fetchvehicleCount = useCallback(() => {
    getDashboardVehiclecount({ period: apiVehiclepayload })
      ?.then((response) => {
        if (!_.isEmpty(_.get(response, "errorMessage", "")) || _.get(response, "success", true) === false) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          setVehicleCount(response);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
  }, [apiVehiclepayload, setApiErrorModalState]);

  useEffect(() => {
    fetchdealerCount();
  }, [apiDealerpayload, fetchdealerCount]);

  useEffect(() => {
    fetchvehicleCount();
  }, [apiVehiclepayload, fetchvehicleCount]);

  const exactNumberStyle = (params) => {
    return (
      <box>
        <span>Exact nr.:</span>
        <span className={styles.exactdigit}>{params.row?.exactNumber}</span>
      </box>
    );
  };

  useEffect(() => {
    const tableHeaderColumns = [
      {
        field: "ID",
        headerName: i18next.t("ID"),
        flex: 1.2,
        sortable: false,
        renderCell: (params) => (
          <TextBoxCompOne
            headerText={params.row?.dealer_Id}
            subText={exactNumberStyle(params)}
            headerTextStyle={styles.headerText}
            subTextStyle={styles.vehicleSubText}
          />
        ),
      },
      {
        field: "dealerName",
        headerName: i18next.t("Dealer"),
        flex: 2.3,
        sortable: false,
        renderCell: (params) => (
          <TextBoxCompOne
            headerText={TooltipWrapper(
              params.row?.dealerName,
              styles.dealerNameDashboardCol,
              30
            )}
            subText={TooltipWrapper(
              `${params.row?.street} ${params.row?.houseNumber}, ${params.row?.postcode} ${params.row?.city}`,
              styles.subText,
              30
            )}
            headerTextStyle={styles.headerText}
            subTextStyle={styles.vehicleSubText}
          />
        ),
      },
      {
        field: "Status",
        headerName: i18next.t("Status"),
        flex: 1.8,
        sortable: false,

        renderCell: (params) => (
          <StatusText
            title="Pending"
            customClass={getStatusClassName(params.row?.status)}
            hasIcon={false}
            data-testid="status"
            textStyle={styles.statusColor}
            showPopover={false}
            defaultId={params.row?.dealer_Id}
            defaultStatus={params.row?.status}
          />
        ),
      },

      {
        field: "lastDate",
        sortable: false,

        headerName: (
          <Box className={styles.twoLineColumn}>
            {` ${i18next.t("Datum melding")}`}
          </Box>
        ),
        flex: 1.5,
        renderCell: (params) => (
          <Box className={styles.statusWraper}>
            {params.row?.lastUpdatedDate === null ||
            params.row?.lastUpdatedDate === undefined
              ? moment(params.row?.createdDate).format("DD-MM-YYYY")
              : moment(params.row?.lastUpdatedDate).format("DD-MM-YYYY")}
          </Box>
        ),
      },
    ];
    setTableHeader(tableHeaderColumns);

    setTableColumnData(dealersList);
  }, [dealersList]);

  const dealerdayCount = (data) => {
    setApiDealerpayload(data);
  };

  const vehicledayCount = (data) => {
    setApiVehiclepayload(data);
  };

  const handleChange = (e, newAligment) => {
    const options = [
      { value: "today", label: "Today", elementValue: "89", period: "1" },
      { value: "week", label: "last 7 days", elementValue: "34", period: "2" },
      {
        value: "month",
        label: "last 30 days",
        elementValue: "56",
        period: "3",
      },
    ];

    setAlignment(newAligment);

    const selectedOption = options.find(
      (option) => option.value === newAligment
    );
    if (selectedOption) {
      const { period } = selectedOption;

      dealerdayCount(period);
      vehicledayCount(period);
    }
  };
  return (
    <Box className={styles.dashboardWrapper} data-testid="Dashboard">
      <Box className={styles.boxWrapperdealer}>
        <Box className={styles.userStyle}>
          {i18next.t("Welcome,")}
          <Box className={styles.carlaTextstyle}>{userName}</Box>
        </Box>
        <DashboardDealer
          TextTitle={i18next.t("No. of incoming dealers")}
          countValue={dealerCount}
          Img={styles.leftImgDealerIcon}
          handleChange={handleChange}
          alignment={alignment}
        />

        <DashboardDealer
          TextTitle={i18next.t("No. of incoming vehicles")}
          countValue={vehicleCount}
          Img={styles.leftImgVehiacleIcon}
          handleChange={handleChange}
          alignment={alignment}
        />

        <Box className={styles.PendingDealerWraper}>
          <Box className={styles.pendingheader}>
            {i18next.t("Pending dealers")} {`(${pendinTablecount})`}
            <Button
              title={i18next.t("View all")}
              iconStyle={styles.downloadIcon}
              buttonType="muibtn-secondary"
              withIcon={true}
              handleClick={() =>
                history("/dealers", { state: { currentTab: 1 } })
              }
            />
          </Box>
          <DataTable
            columns={tableHeader}
            rows={tableColumnData}
            isShowMessage={true}
            isShowTableWhenNoResult={true}
            disableColumnMenu={true}
            disableColumnFilter={true}
            hideFooter={true}
            isCheckboxSelection={false}
            disableRowSelectionOnClick={true}
            className={styles.dataTable}
          />
        </Box>

        <Box className={styles.softwareSystemWrapper}>
          <Paper className={styles.softwareSystemContainer}>
            <SoftwareGraphComponent />
          </Paper>
        </Box>
        <Box className={styles.bottomGraphWrapper}>
          <Box className={styles.softwareSystemWrapper}>
            <Paper className={styles.turnOverGraphContainer}>
              <TurnoverGraphComponent />
            </Paper>
          </Box>
          <Box className={styles.dashTrademarkWrapper}>
            <Paper className={styles.turnOverGraphContainer}>
              <TrademarkGraphComponent />
            </Paper>
          </Box>
          <Box className={styles.ApiDashboardStatusWrapper}>
            <Paper className={styles.apistatusContainer}>
              <ApiStatusDashboardcomponent />
            </Paper>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
